import './mobileArrow.css';

export default function MobileArrow({rotate, className, onClick}) {
    return(
        <div className={className} onClick={onClick}>
            <svg width="65" height="65" viewBox="0 0 65 65" style={{transform: `rotate(${rotate}deg)`, transformOrigin: 'center center'}}>
                <g id="Group_970" data-name="Group 970" transform="translate(-333 -568)">
                    <circle id="Ellipse_160" data-name="Ellipse 160" cx="32.5" cy="32.5" r="32.5" transform="translate(333 633) rotate(-90)" fill="#72bf72"/>
                    <path id="Icon_ion-arrow-left-c" data-name="Icon ion-arrow-left-c" d="M17.107,9.354,6.57,20.384a3.4,3.4,0,0,0,0,4.706L17.107,36.163a3.106,3.106,0,0,0,4.538,0,3.475,3.475,0,0,0,0-4.748L16.592,26.12h22.8a3.365,3.365,0,0,0,0-6.723h-22.8L21.656,14.1a3.475,3.475,0,0,0,0-4.748,3.119,3.119,0,0,0-4.549,0Z" transform="translate(341.375 577.631)" fill="#fff"/>
                </g>
            </svg>
        </div>
    )
}